<template>
  <div :id="role.id" class="list-box-container"
       @mouseup="($_can('roles.show') ||
         $_can('roles.view-own'))"
  >
    <template>
      <div class="d-flex list-box-header col-12 pointer" @click.middle.exact="viewMiddle($event, role.id)" @click.left.exact="view($event, role.id)">
        <div class="pl-0 list-box-header-left col-lg-7 col-7 pr-3">
          <div class="pl-0 d-flex align-items-center col-7">
            <div class="list-box-status align-items-start col-12">
              <span class="ref-id">
                {{ role.name }}
              </span>
            </div>
          </div>
          <div class="pl-0 d-flex align-items-center col-5">
            <div class="list-box-status align-items-start col-12">
              <span>
                {{ role.carrier_id }}
              </span>
            </div>
          </div>
        </div>
        <div class="list-box-header-right col-lg-5 col-5 pl-4">
          <div class="d-flex align-items-center col-7">
            <div class="role-roles">
              <span class="dispatch-roles" v-if="role.department && role.department.name === 'Dispatch'">
                Dispatch
              </span>
              <span class="management" v-if="role.department && role.department.name === 'Management'">
                Management
              </span>
              <span class="sales-roles" v-if="role.department && role.department.name === 'Sales'">
                Sales
              </span>
              <span class="claims-roles" v-if="role.department && role.department.name === 'Claims'">
                Claims
              </span>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    role: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({}),
  methods: {
    viewMiddle(event, id) {
      const routeData = this.$router.resolve({
        path: `/settings/user-roles/edit/${id}`,
        query: { data: this.q },
      });
      window.open(routeData.href, '_blank');
    },
    view(event, id) {
      this.$router.push(
        `/settings/user-roles/edit/${id}${this.q ? `?q=${encodeURIComponent(this.q)}` : ''}`,
      );
    },
  },
};
</script>
<style lang="scss" scoped>
a {
  text-decoration: none;
}
.claim-closed {
  background-color: #2962ff;
  display: flex;
  color: #fff;
  border-radius: 4px;
  padding: 14px;
  height: 52px;
}
.list-box-status {
  align-items: normal;
}
.list-box-header {
  min-height: 66px;
}
.role-roles {
  display: flex;
}
.full-name {
  font-weight: 500;
  font-size: 16px;
  color: #4c5669;
}
</style>



// WEBPACK FOOTER //
// src/components/settings/UserRoles/SettingsUserRolesBlock.vue